import React from 'react';
import { SectionCompaniesTypes } from './styles/TypesOfCompaniesBlock.styled';
import TypesOfCompaniesHeader from './CompaniesTypesHeader';
import TypesOfCompaniesBlock from './CompaniesTypesBlock';

export default function CompanyTypes({ data, id, dir }) {
  return (
    <SectionCompaniesTypes id={id} dir={dir}>
      <TypesOfCompaniesHeader data={data} dir={dir} />
      <TypesOfCompaniesBlock data={data} dir={dir} />
    </SectionCompaniesTypes>
  );
}
